<template>
    <div name="navigation-bar" class="bar">
        <div class="inner">
            <img style="width: 104px;" src="../../../assets/logo_pc.png" />
            <div> 
                <span @click="change('/campaign/ranking')" class="button-active" style="margin-right: 72px;">불편접수함</span>
                <span class="button-inactive" style="margin-right: 72px;">불편 사례 순위<span class="small-text" style="margin-left: 8px; ">준비중</span></span>
                <span @click="change('/campaign/improvement')" class="button-active">이렇게 개선했어요!</span>
            </div>
            <span @click="goHome" class="button-active">홈페이지 바로가기</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigationBar',
    methods: {
        change: function(route)
        {   
            this.$emit('change', route)
        },
        goHome: function()
        {
            // window.location.href = 'https://concierge.soldoc.co.kr';
            window.open('https://concierge.soldoc.co.kr/barocarenew?utm_source=UncomfortableMoment_250708&utm_medium=UncomfortableMoment_250708&utm_campaign=UncomfortableMoment_250708&utm_content=UncomfortableMoment_250708&utm_term=UncomfortableMoment_250708', "_blank")
        }
    }
}
</script>

<style scoped>
    .bar {
        display: flex;
        width: 100%;
        height: 72px;
        justify-content: center;
        align-items: center;
        background: var(--Gray-00, #FFF);
        position: fixed;
        z-index: 1;
    }
    .inner {
        width: 1296px;
        height: 72px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .button-active {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
        cursor: pointer;
    }
    .button-inactive {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    
    .small-text {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        height: 24px;
        border-radius: 3px;
        background: var(--Gray-20, #F3F5F8);
        padding: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/NavigationBar.vue